module.exports = "./img/12f842785be1e05b72eccfae95a47ba0.png";